import { SubjectData } from 'shell/models/person';
import { AccordionVoidCivilUnion } from 'shell/components/shared/sipo-person-form/new-person';
import { DateTime } from 'luxon';

export const transformVoidCivilUnion = (
  person: SubjectData
): AccordionVoidCivilUnion | undefined => {
  const originReturnData: AccordionVoidCivilUnion | undefined = person.unioneCivile
    ?.scioglimentoUnione
    ? {
        number: person.unioneCivile?.scioglimentoUnione?.sentenza?.numero
          ? Number.parseInt(person.unioneCivile?.scioglimentoUnione?.sentenza?.numero, 10)
          : 0,
        eventDate:
          person.unioneCivile?.scioglimentoUnione?.sentenza?.data ||
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.dataEvento
            ? DateTime.fromISO(
                person.unioneCivile?.scioglimentoUnione?.sentenza?.data ||
                  person.unioneCivile?.scioglimentoUnione?.datiEvento?.dataEvento ||
                  ''
              )
            : null,
        validityDate: person.unioneCivile?.scioglimentoUnione?.sentenza?.dataValidita
          ? DateTime.fromISO(person.unioneCivile?.scioglimentoUnione?.sentenza?.dataValidita)
          : null,
        courtType: person.unioneCivile?.scioglimentoUnione?.sentenza?.tipoTribunale || '',
        authority: person.unioneCivile?.scioglimentoUnione?.sentenza?.autorita || '',
        type: person.unioneCivile?.scioglimentoUnione?.motivoScioglimento?.toString() || '',
        location:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.luogoEvento?.comune
            ?.descrizioneLocalita || '',
        // paper
        municipality: person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
          ?.comuneRegistrazione?.codiceIstat
          ? {
              id:
                person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
                  ?.comuneRegistrazione?.codiceIstat || '',
              description:
                person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
                  ?.comuneRegistrazione?.nomeComune || '',
              province:
                person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
                  ?.comuneRegistrazione?.siglaProvinciaIstat || '',
            }
          : null,
        year: person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.anno || '',
        province:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.luogoEvento?.comune
            ?.siglaProvinciaIstat || '',
        documentNumber:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.numeroAtto ||
          '',
        portion:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.parte || '',
        range:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.serie || '',
        regVol:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.volume || '',
        office:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
            ?.ufficioMunicipio || '',
        documentDate: person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
          ?.dataFormazioneAtto
          ? DateTime.fromISO(
              person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto
                ?.dataFormazioneAtto
            )
          : null,
        transcript:
          person.unioneCivile?.scioglimentoUnione?.datiEvento?.attoEventoANPR?.atto?.trascritto ===
          '1'
            ? true
            : false,
      }
    : undefined;

  return originReturnData;
};
